import { User as UsuarioOidc } from 'oidc-client-ts';
import { ReactElement } from 'react';
export interface BasicUser {
  emailUtilizado: string;
  id: string;
}

export type Auth<T extends BasicUser> = {
  pending: boolean;
  authorized: boolean;
  authenticated: boolean;
  user: Usuario<T> | null;
  loginProblem: string | null;
};

export interface ConfigUsuario {
  visualizouOnboarding?: boolean;
  visualizouGapDisciplinas?: boolean;
  visualizouAvisoBDQ?: boolean;
  visualizouAvisoLabVirtual?: boolean;
  visualizouAvisoBibliotecaVirtual?: boolean;
  visualizouAvisoEmpregabilidade?: boolean;
  visualizouAvisoAgendamentoLaboratorio?: boolean;
  visualizouAvisoCursosLivres?: boolean;
  visualizouAvisoAgendamentoPraticasPresenciais?: boolean;
  trilhaSingular?: string;
  urlComunidadeSingular?: string;
  secaoSingular?: string;
  faseSingular?: number;
}

export enum Situacao {
  ATIVO = 'ATIVO',
  FORMANDO = 'FORMANDO',
  INATIVO = 'INATIVO',
}

export enum Modalidade {
  PRESENCIAL = 'PRESENCIAL',
  SEMIPRESENCIAL = 'SEMIPRESENCIAL',
  TOTAL_EAD = 'TOTAL EAD',
  AO_VIVO = 'AO VIVO',
  FLEX_ESPECIAL = 'FLEX ESPECIAL',
}

export interface TurmaCursada {
  id: string;
  situacao: string;
  periodoMatricula: string;
}

export interface Matricula {
  id: string;
  idExterno?: string;
  nomeCurso: string;
  tipoCurso: string;
  campus: string;
  turno: string;
  situacao: Situacao;
  calendario: string;
  entregas: string[];
  modalidade: Modalidade;
  matricula?: string;
  periodo?: string;
  periodosAnteriores: string[];
  codigoCurso?: string;
  turmasCursadas?: TurmaCursada[];
  periodoFlexivelAtual?: string;
  totalPeriodosCurso?: string;
  safra?: string;
}

export interface PerfilAluno extends BasicUser {
  id: string;
  idExterno?: string;
  nome: string;
  credenciais: string[];
  marca: string;
  matriculas: Matricula[];
  config: ConfigUsuario;
}

export interface PerfilEducador extends BasicUser {
  id: string;
  nome: string;
  marca: string;
  cpf: string;
  curriculoLatesURL: string;
  calendarios: string[];
  entregas: string[];
  credenciais: string[];
  config: ConfigUsuario;
  dataAtualizacao: Date;
}

export interface IUsuarioContext<T> {
  autorizado: boolean;
  autenticado: boolean;
  pendente: boolean;
  problemaLogin: string;
  usuario: Usuario<T>;
}

export interface Props {
  onLoading: ReactElement;
  children: React.ReactNode;
}

export type Provider = React.FC<Props>;

export interface ConfigSupplier {
  getOnboardingFinalizado: () => boolean;
  getVisualizouAvisoBDQ: () => boolean;
  possuiGapDisciplinas: () => boolean;
  visualizouGapDisciplinas: () => boolean;
  visualizouOnboarding: () => boolean;
  visualizouAvisoLabVirtual: () => boolean;
  visualizouAvisoCursosLivres: () => boolean;
  visualizouAvisoAgendamentoPraticasPresenciais: () => boolean;
  visualizouAvisoAgendamentoLaboratorio: () => boolean;
  getTrilhaSingular: () => string;
  getUrlComunidadeSingular: () => string;
  getSecaoSingular: () => string;
  getFaseSingular: () => number;

  salvarConfigUsuario: (config: ConfigUsuario) => Promise<void>;
}
export interface HookProps {
  salvarConfigUsuario: (config: ConfigUsuario) => Promise<void>;
}
export interface UsuarioAura<T> {
  dados: T;
  perfil: 'ALUNO' | 'EDUCADOR';
}

export interface Usuario<T> {
  oidc: UsuarioOidc;
  aura: UsuarioAura<T>;
  logoff: (motivo: string) => void;
}

export interface HookResult {
  get: <T>() => Usuario<T>;
  /**
   * @deprecated Será removido ao ativar a nova experiência de turmas cursadas
   */
  getTurmasCursadasAluno: () => TurmaCursada[];
  /**
   * @deprecated Será removido ao ativar a nova experiência de turmas cursadas
   */
  getPeriodosAnterioresAluno: () => string[];
  autorizado: () => boolean;
  pendente: () => boolean;
  problemaLogin: string;
  config: ConfigSupplier;
}

export type Hook = () => HookResult;
